var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateSector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    "data-name": "Group 2119",
    transform: "translate(-131 -3231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    "data-name": "Group 2218"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    transform: "translate(131 3231)",
    fill: "#f5f5de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M19.68,4.139a4.31,4.31,0,0,0-4.286,4.286V36.988a4.305,4.305,0,0,0,4.286,4.281H34.335v5.788H1.865a1.353,1.353,0,1,0,0,2.706H7.277V66H9.982V49.762H72.216V66h2.706V49.762h5.412a1.353,1.353,0,1,0,0-2.706H47.864V41.268H62.519A4.305,4.305,0,0,0,66.8,36.988V8.425a4.31,4.31,0,0,0-4.286-4.286Zm0,2.852H62.519a1.4,1.4,0,0,1,1.434,1.434V33.151H18.246V8.425a1.4,1.4,0,0,1,1.431-1.434ZM18.246,35.857H40.961a1.353,1.353,0,0,0-.449,2.552H19.68c-.817,0-1.434-2.24-1.434-1.426Zm22.875,0H63.95v1.131a1.393,1.393,0,0,1-1.431,1.423H41.676c.022-.014.046-.019.068-.032a1.325,1.325,0,0,0,.116-.068l.108-.087a1.35,1.35,0,0,0,.271-1.726.974.974,0,0,0-.076-.108,1.353,1.353,0,0,0-.52-.422.881.881,0,0,0-.127-.046,1.348,1.348,0,0,0-.4-.065Zm-4.08,5.412h8.117v5.788H37.041Z",
    transform: "translate(152.507 3258.861)",
    fill: "#335f32",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateSector);
export default __webpack_public_path__ + "static/media/privateSector.f0cb8d6515439235a91000369c437e4c.svg";
export { ForwardRef as ReactComponent };